export default {
  DOMAIN: 'domain',
  DIFM_PRIVACY: 'difm_privacy',
  DIFM_SERVICE: 'difm_service',
};
